import React, { useRef, useState } from 'react'
import clsx from 'clsx'

import Heading from '../Heading/Heading'
import Icon from '../Icon/Icon'

export const NewsLetter = ({ otherClasses }) => {
  const newsLetterClasses = clsx(
    otherClasses,
    'bg-primary_heading_color border-b border-[#5E5E60] lg:py-[100px] py-16 '
  )

  const [userEmail, setUserEmail] = useState('')

  function encode(data) {
    const formData = new FormData()
    for (const key of Object.keys(data)) {
      formData.append(key, data[key])
    }
    return formData
  }

  async function handleSubmit(e) {
    e.preventDefault()
    const form = e.target
    try {
      await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': form.getAttribute('name'),
          email: userEmail,
        }),
      })
      setUserEmail('')
      form.reset()
    } catch (error) {
      alert(error)
    }
  }

  return (
    <div className={newsLetterClasses} data-testid="news-letter">
      <div className="max-w-[1512px] mx-auto xl:px-[156px] lg:px-20 px-6 relative">
        <div className="flex lg:flex-row flex-col items-center gap-6 justify-center">
          <div className="lg:w-[45%] w-full">
            <Heading
              type="h3"
              otherClasses="text-[24px] leading-normal lg:text-[30px] font-semibold text-white lg:text-right text-left md:text-center"
            >
              Never Miss a Property
            </Heading>
          </div>
          <div className="lg:w-[55%] w-full">
            <form
              action=""
              method="POST"
              name="Subcriber Form"
              className="w-full"
              onSubmit={handleSubmit}
            >
              <div className="flex items-center lg:justify-start justify-center gap-4 w-full">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Your Email Address"
                  required
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  className="w-full max-w-[440px] outline-[1px] outline outline-[#fff] bg-transparent rounded-[24px] py-[13px] px-4 h-[45px] placeholder:text-white text-white font-work-sans text-[16px] leading-normal font-normal hover:bg-[#39393A] transition-bg ease-in-out duration-200 focus:outline-2 focus:outline-[#2D7CF1] active:bg-transparent active:outline active:outline-[#fff]"
                />
                <button
                  type="submit"
                  className="focus:border-2 focus:border-[#2D7CF1] rounded-[10px]"
                >
                  <Icon
                    icon="right-arrow-icon"
                    iconHeight={40}
                    iconWidth={40}
                  />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsLetter
